import React, { ReactNode } from 'react';
import MuiAutocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import TextField from '../controls/TextField';
import { InputBaseComponentProps } from "@mui/material";

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>

type Props = Omit<AutocompleteProps<string, true, true, true>, 'renderInput'> & {
    label: string,
    renderInput?: (o: object) => ReactNode,
    error?: boolean,
    helperText?: string | ReactNode,
    inputProps?: InputBaseComponentProps,
    // freeSolo?: boolean,
    name?: string,
    id?: string,
}

const Autocomplete: React.FC<Props> = ({ label, defaultValue, inputProps,
    filterSelectedOptions = true, error,
    name, id,
    helperText, options, ...props }) => {


    return (
        <MuiAutocomplete
            multiple
            options={options}
            selectOnFocus={true}
            getOptionLabel={(option) => option}
            defaultValue={defaultValue}
            filterSelectedOptions={filterSelectedOptions}
            renderInput={(params) => {
                return (
                    <TextField
                        {...params}
                        name={name}
                        id={id}
                        inputProps={{ ...inputProps, ...params.inputProps }}
                        variant="outlined"
                        label={label}
                        error={error}
                        helperText={helperText}
                    />
                )
            }}
            {...props}
        />
    )
}

export default Autocomplete;